<div class="p-col-12 p-lg-12 mb30">
  @if (loading) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <div class="ui-g card">
    <div class="ui-g-12 ui-md-12 ui-lg-12 tbst">
      <p-table
        #pa
        [columns]="cols"
        [scrollable]="true"
        [style]="{ width: '100%' }"
        [value]="downloadCSV"
        selectionMode="single"
        [loadingIcon]="loadingIcon"
        [showLoader]="true"
        [(selection)]="selectedItem"
        [paginator]="true"
        [rows]="24"
        paginatorPosition="both">
        <ng-template #header>
          <tr>
            <th [pSortableColumn]="'fileName'" class="collarge">
              File Name <p-sortIcon [field]="'fileName'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'createdOn'" class="collarge">
              File Created on (PST)
              <p-sortIcon [field]="'createdOn'"></p-sortIcon>
            </th>
            <th class="colsmall" style="text-align: center">Download CSV</th>
          </tr>
          <tr></tr
        ></ng-template>
        <ng-template #body let-downloadCSV let-columns="columns">
          <tr>
            <td class="collarge">{{ downloadCSV.fileName }}</td>
            <td class="collarge">{{ downloadCSV.createdOn }}</td>
            <td class="colsmall text-center">
              <button
                (click)="downloadFile(downloadCSV)"
                tooltipPosition="top"
                pTooltip="{{ downloadCSV.fileName }}"
                class="edit-button-link">
                <i
                  class="fa fa-file-excel-o"
                  aria-hidden="true"
                  style="font-size: 16px"></i>
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
